import React from 'react';

interface DayPickerProps {
  selectedDays: number[];
  onChange: (days: number[]) => void;
  label?: string;
  required?: boolean;
}

const DayPicker: React.FC<DayPickerProps> = ({ selectedDays, onChange, label, required }) => {
  // Values match JS Date.getUTCDay()/getDay() (0 = Sunday), since that is what
  // every availability computation compares repeatDaysOfWeek against.
  const days = [
    { value: 0, label: 'Sun' },
    { value: 1, label: 'Mon' },
    { value: 2, label: 'Tue' },
    { value: 3, label: 'Wed' },
    { value: 4, label: 'Thu' },
    { value: 5, label: 'Fri' },
    { value: 6, label: 'Sat' },
  ];

  const toggleDay = (dayValue: number) => {
    if (selectedDays.includes(dayValue)) {
      onChange(selectedDays.filter((d) => d !== dayValue));
    } else {
      onChange([...selectedDays, dayValue].sort());
    }
  };

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
          {required && <span className="text-red-600 ml-1">*</span>}
        </label>
      )}
      <div className="flex flex-wrap gap-2">
        {days.map((day) => {
          const isSelected = selectedDays.includes(day.value);
          return (
            <button
              key={day.value}
              type="button"
              onClick={() => toggleDay(day.value)}
              className={`
                px-4 py-2 rounded-lg text-sm font-medium transition-colors
                ${
                  isSelected
                    ? 'bg-primary-600 text-white hover:bg-primary-700'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }
              `}
            >
              {day.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DayPicker;

